module.exports = __webpack_public_path__ + "static/media/Pulse Module 3.7f85eb5b.jpg";